export const questionTypes = {
    dropdown: "DDL",
    text: "TEXT",
    datetime: "DATETIME",
    number: "NUMBER",
    checkbox: "CHECKBOX",
    decimal: "DECIMAL",
    file: "FILE",
    sketch: "SKETCH",
    notextlimit: "NOTEXTLIMIT",
    // map: "MAP", // Potentially require MAP question type in the future
};

export const FILE_QUESTION_TYPES = ["file", "sketch"];
